"use client"

import { Button } from "@/components/ui/button"
import Image from "next/image"
import { Video, Shield, Clock, Globe, MessageCircle } from "lucide-react"

export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  
  return (
    <section className="pt-24 sm:pt-28 pb-12 sm:pb-16 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 min-h-screen flex items-center">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Text Content */}
          <div className="text-center lg:text-left order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-800 rounded-full px-3 sm:px-4 py-2 mb-4 sm:mb-6 font-medium text-sm sm:text-base">
              <Video className="h-3 w-3 sm:h-4 sm:w-4" />
              Онлайн консультации
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-slate-900 mb-4 sm:mb-6 leading-tight">
              Путь к внутренней<span className="text-indigo-600 block sm:inline"> гармонии  и</span> <span className="text-indigo-600 block sm:inline">здоровью</span>{" "}
              <span className="block sm:inline">начинается здесь</span>
            </h1>

            <p className="text-base sm:text-lg lg:text-xl text-slate-600 mb-6 sm:mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              Профессиональная психологическая помощь и гипнотерапия онлайн. Работаю с клиентами по всему миру, создавая
              безопасное пространство для изменений.
              <br />
              <br />
              Помогаю решить вопросы со здоровьем с помощью гипноза, психотерапии и инструментов психосоматики - аллергические, хронические, аутоимунные, кожные заболевания успешно излечиваются. Работаю с депрессивными, тревожными состояниями, страхами, фобиями, самоценностью, эмоциями, ПТСР.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start mb-6 sm:mb-8">
              <Button
                onClick={() => scrollToSection("booking")}
                size="lg"
                className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 sm:px-8 py-3 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg text-sm sm:text-base w-full sm:w-auto"
              >
                Записаться на консультацию
              </Button>
              <div className="flex gap-2 sm:gap-3">
                <a
                  href="https://wa.me/79226268052"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-2 border-green-600 text-green-600 hover:bg-green-600 hover:text-white px-4 sm:px-6 py-3 rounded-lg transition-all duration-300 text-sm sm:text-base flex-1 sm:flex-none bg-transparent flex items-center justify-center"
                >
                  <MessageCircle className="mr-2 h-4 w-4" />
                  WhatsApp
                </a>
                <a
                  href="https://t.me/OxanaZayakina"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-4 sm:px-6 py-3 rounded-lg transition-all duration-300 text-sm sm:text-base flex-1 sm:flex-none bg-transparent flex items-center justify-center"
                >
                  <MessageCircle className="mr-2 h-4 w-4" />
                  Telegram
                </a>
              </div>
            </div>

            {/* Features */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-2xl mx-auto lg:max-w-none lg:mx-0">
              {[
                { icon: Video, text: "Google Meet" },
                { icon: Shield, text: "Конфиденциально" },
                { icon: Clock, text: "Гибкий график" },
                { icon: Globe, text: "Международно" },
              ].map((feature, index) => (
                <div key={index} className="flex flex-col items-center gap-2 text-slate-600 p-3">
                  <feature.icon className="h-5 w-5 text-indigo-600 flex-shrink-0" />
                  <span className="text-sm font-medium text-center leading-tight">{feature.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="flex justify-center lg:justify-end order-1 lg:order-2">
            <div className="relative w-full max-w-xs sm:max-w-sm lg:max-w-md">
              <Image
                src="/images/ph.jpg"
                alt="Оксана Заякина - Психолог"
                width={260}
                height={370}
                className="rounded-2xl shadow-2xl w-full h-auto"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
